import styles from './bundleOccasionsList.module.css'
import { upperFirst } from 'lodash'
import { getCardCategoryDetailsForOccasionKey } from 'config/cardOptions'
import classNames from 'classnames'

type Props = {
  categoryTitles: string[],
  suppressMargins?: boolean,
}

const BundleOccasionsList = ({ categoryTitles, suppressMargins = false }: Props) => {
  const categoryDetails = categoryTitles?.map(categoryTitle => getCardCategoryDetailsForOccasionKey(categoryTitle))
  return <div className={classNames(styles.occasions, { [styles.suppressMargins]: suppressMargins })}>{ categoryDetails?.map(category =>
    <div key={category?.label} className={styles.occasion}>
      <span dangerouslySetInnerHTML={{ __html: category?.emojiLabel }} />
      <span>{upperFirst(category?.label)}</span>
    </div>
  ) }</div>
}

export default BundleOccasionsList
